export const newsDetail = {
  showListButton: '목록으로',
  prev: '이전',
  next: '다음',
  toastMessage: '링크가 복사되었습니다.',
}
